import React from 'react';
import { useTranslation } from 'react-i18next';
import linkedinAvatar from '../images/perfil-geral.png';

const linkedinProfile = {
  name: 'Laert Furquin',
  quickTags: [
    'TypeScript',
    'Node.js',
    'NestJS',
    'PostgreSQL',
    'Prisma',
    'Docker',
    'APIs REST',
  ],
  profileUrl: 'https://www.linkedin.com/in/laert-furquin/',
};

export function LinkedInCard() {
  const { t } = useTranslation();
  const p = linkedinProfile;
  const highlights = [t('linkedin.highlight1'), t('linkedin.highlight2')];
  const bioParagraphs = [
    t('linkedin.bio1'),
    t('linkedin.bio2'),
    t('linkedin.bio3'),
  ];

  return (
    <div className="relative flex h-full min-h-0 w-full flex-col overflow-hidden rounded-3xl">
      <div className="relative flex h-full min-h-0 flex-1 flex-col px-4 pb-6 pt-5 sm:px-6 sm:pb-7 sm:pt-6">
        <h2 className="mb-4 shrink-0 text-center text-lg font-semibold tracking-wide text-white/95 lg:mb-5">
          {t('linkedin.titulo')}
        </h2>

        <div className="flex min-h-0 flex-1 flex-col rounded-3xl border border-white/15 bg-white/[0.07] p-1 shadow-lg shadow-blue-500/10 backdrop-blur-xl">
          <div className="shrink-0 rounded-2xl border border-white/10 bg-white/[0.06] p-4 backdrop-blur-md sm:p-5 md:p-6">
            <div className="flex flex-col gap-4 sm:flex-row sm:gap-5">
              <div className="flex w-full max-w-full shrink-0 flex-col items-center gap-2 sm:w-[7.5rem] sm:items-start">
                <img
                  src={linkedinAvatar}
                  alt={`Foto de perfil de ${p.name}`}
                  className="h-[4.5rem] w-[4.5rem] rounded-full object-cover ring-2 ring-white/35 ring-offset-2 ring-offset-slate-900/50 sm:h-20 sm:w-20"
                />
                <ul className="w-full max-w-md space-y-1.5 border-t border-white/10 pt-3 text-left text-[10px] leading-relaxed text-gray-400 sm:max-w-none sm:text-[11px]">
                  {highlights.map((line) => (
                    <li key={line} className="flex items-start gap-1.5 break-words">
                      <span className="mt-1 h-1 w-1 shrink-0 rounded-full bg-emerald-400/80" />
                      <span>{line}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex min-w-0 flex-1 flex-col gap-4 sm:gap-5">
                <div className="min-w-0">
                  <p className="break-words text-lg font-bold leading-tight text-white sm:text-xl">
                    {p.name}
                  </p>
                  <p className="mt-2 break-words text-xs leading-relaxed text-gray-300 sm:text-sm">
                    {t('linkedin.headline')}
                  </p>
                </div>

                <div>
                  <p className="mb-2 text-[10px] font-semibold uppercase tracking-wide text-white/45 sm:mb-2.5">
                    {t('linkedin.stackDestaque')}
                  </p>
                  <div className="flex flex-wrap gap-2 sm:gap-x-2.5 sm:gap-y-2">
                    {p.quickTags.map((tag) => (
                      <span
                        key={tag}
                        className="inline-flex rounded-full border-2 border-white/15 bg-white/[0.07] px-2.5 py-1 text-[10px] font-medium text-gray-200 shadow-sm shadow-black/10 transition-all duration-300 hover:scale-105 hover:border-orange-500 hover:shadow-orange-500/15 sm:text-[11px]"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex min-h-0 flex-1 flex-col justify-start border-t border-white/10 px-4 py-5 sm:px-5">
            <div className="space-y-3 text-sm leading-loose text-gray-300 sm:space-y-4 sm:text-base">
              {bioParagraphs.map((paragraph, i) => (
                <p key={i} className="break-words">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>

          <div className="mt-auto shrink-0 px-4 pb-5 pt-2 sm:px-5">
            <a
              href={p.profileUrl}
              target="_blank"
              rel="noreferrer"
              className="flex w-full items-center justify-center rounded-xl bg-white py-3 text-center text-xs font-bold uppercase tracking-wide text-blue-600 shadow-[0_8px_32px_-8px_rgba(59,130,246,0.55)] transition hover:bg-white/95 hover:text-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400 sm:py-3.5 sm:text-sm"
            >
              {t('linkedin.visitarPerfil')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LinkedInCard;
